import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { catchError, map} from 'rxjs/operators';
import { AutorizationService } from '../api/autorization.service';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardServiceService implements CanActivate{

  constructor(private AutorizationService : AutorizationService, router : Router) { }


  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) : Observable<any> {
    return this.AutorizationService.isAuth().pipe(
      map(e => {
        console.log("CanActivate");
        console.log(e);
        // conslog(e);
        if (e) {
          return true;
        } else {
          return false;
          
        }
      }),
      catchError((err) => {
        return of(false);
      })
    );
  }

}

